/**
 *
 * @param items *[]
 * @returns {*[]}
 */
export const deduplicateList = (items) => Array.from(new Set([
  ...items,
]));
